import { NavLink, Navigate, Route, Routes } from "react-router-dom";
import {
  OrganizationSwitcher,
  SignIn,
  SignUp,
  SignedIn,
  SignedOut,
  UserButton,
} from "@clerk/clerk-react";
import { Logo } from "./components/Logo.tsx";
import Sessions from "./pages/Sessions.tsx";
import Skills from "./pages/Skills.tsx";
import SkillDetail from "./pages/SkillDetail.tsx";
import SkillEdit from "./pages/SkillEdit.tsx";
import Tokens from "./pages/Tokens.tsx";
import Billing from "./pages/Billing.tsx";
import GettingStarted from "./pages/GettingStarted.tsx";

const NAV = [
  { to: "/sessions", label: "Sessions" },
  { to: "/skills", label: "Skills" },
  { to: "/tokens", label: "Tokens" },
  { to: "/billing", label: "Billing" },
  { to: "/start", label: "Get started" },
];

// Local design preview: skip the Clerk gate and render the shell with mock data.
const PREVIEW = import.meta.env.VITE_PREVIEW === "1";

function Shell() {
  return (
    <div className="app">
      <header className="topbar">
        <div className="topbar-left">
          <NavLink to="/sessions" className="brand" aria-label="Stift Cloud">
            <Logo />
            <span className="brand-name">
              stift<span className="brand-cloud">cloud</span>
            </span>
          </NavLink>
          <div className="org-switch">
            {PREVIEW ? (
              <span className="preview-org">Acme Inc ▾</span>
            ) : (
              <OrganizationSwitcher
                hidePersonal
                afterCreateOrganizationUrl="/sessions"
                afterSelectOrganizationUrl="/sessions"
              />
            )}
          </div>
        </div>

        <nav className="nav">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                isActive ? "nav-link nav-link--active" : "nav-link"
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="topbar-right">
          {PREVIEW ? <span className="preview-user" /> : <UserButton />}
        </div>
      </header>

      <main className="main">
        <Routes>
          <Route path="/sessions" element={<Sessions />} />
          <Route path="/skills" element={<Skills />} />
          <Route path="/skills/:scope/:agent/*" element={<SkillDetail />} />
          <Route path="/skills/edit/:scope/:agent/*" element={<SkillEdit />} />
          <Route path="/tokens" element={<Tokens />} />
          <Route path="/billing" element={<Billing />} />
          <Route path="/start" element={<GettingStarted />} />
          <Route path="*" element={<Navigate to="/sessions" replace />} />
        </Routes>
      </main>
    </div>
  );
}

function AuthGate() {
  return (
    <div className="auth-screen">
      <div className="auth-hero">
        <Logo size={40} />
        <h1>
          stift<span className="brand-cloud">cloud</span>
        </h1>
        <p>Sync, browse, and share your AI coding-agent sessions.</p>
      </div>
      <div className="auth-card">
        <Routes>
          <Route
            path="/sign-up/*"
            element={<SignUp routing="path" path="/sign-up" signInUrl="/" />}
          />
          <Route
            path="*"
            element={
              <SignIn routing="path" path="/" signUpUrl="/sign-up" />
            }
          />
        </Routes>
      </div>
    </div>
  );
}

export default function App() {
  if (PREVIEW) return <Shell />;
  return (
    <>
      <SignedIn>
        <Shell />
      </SignedIn>
      <SignedOut>
        <AuthGate />
      </SignedOut>
    </>
  );
}
